export default "__VITE_ASSET__5e6cabe3__"